/* ============================================================
   URZA — CUSTOM JS  ·  Tema Focal v13
   ------------------------------------------------------------
   1. Favoritos nos cards (coração)
   2. Lightbox da galeria
   3. Selos sobre a galeria
   4. Ícone Pix no rodapé
   5. Botão "Continuar comprando" no carrinho
   6. Favoritos: ícone no header + drawer
   7. Cupom e totais no carrinho
   8. Esconde o WhatsApp com a barra sticky
   ============================================================ */


/* ============================================================
   1. FAVORITOS NOS CARDS
   ============================================================ */
(function () {
  var STORAGE_KEY = 'urza:favoritos';

  function getFavs() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveFavs(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('urza:favoritos-mudou'));
  }

  var HEART_SVG =
    '<svg viewBox="0 0 24 24" stroke-width="2" aria-hidden="true">' +
    '<path d="M12 21s-7.5-4.9-10-9.6C.5 8 2.5 4.5 6 4.5c2.1 0 3.6 1.2 4.5 2.6' +
    'l1.5 2.2 1.5-2.2c.9-1.4 2.4-2.6 4.5-2.6 3.5 0 5.5 3.5 4 6.9' +
    'C19.5 16.1 12 21 12 21z"/></svg>';

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }

  function injectHearts(root) {
    var favs = getFavs();
    (root || document).querySelectorAll('product-item').forEach(function (card) {
      if (card.querySelector('.urza-favorite')) return;
      var handle = handleFromCard(card);
      if (!handle) return;

      var media = card.querySelector('.product-item__image-wrapper, .product-item__media, a[href*="/products/"]');
      if (!media) return;
      if (getComputedStyle(media).position === 'static') {
        media.style.position = 'relative';
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'urza-favorite';
      btn.setAttribute('aria-label', 'Adicionar aos favoritos');
      btn.innerHTML = HEART_SVG;
      if (favs.indexOf(handle) !== -1) btn.classList.add('ativo');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = getFavs();
        var i = list.indexOf(handle);
        if (i === -1) { list.push(handle); btn.classList.add('ativo'); }
        else { list.splice(i, 1); btn.classList.remove('ativo'); }
        saveFavs(list);
      });

      media.appendChild(btn);
    });
  }

  /* mantém os corações em sincronia quando algo é removido no drawer */
  document.addEventListener('urza:favoritos-mudou', function () {
    var favs = getFavs();
    document.querySelectorAll('product-item').forEach(function (card) {
      var btn = card.querySelector('.urza-favorite');
      if (!btn) return;
      var handle = handleFromCard(card);
      if (!handle) return;
      btn.classList.toggle('ativo', favs.indexOf(handle) !== -1);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { injectHearts(); });
  } else {
    injectHearts();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { injectHearts(); break; }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   2. LIGHTBOX DA GALERIA (trilho deslizante, com vídeo)
   ------------------------------------------------------------
   ESTRUTURA: um trilho com todas as mídias lado a lado, movido
   por translateX. O zoom vive na MÍDIA, o deslize no TRILHO.

   FOTO  → pinça, duplo toque, arrasto da imagem ampliada
   VÍDEO → sem zoom; clique dá play/pause. Só o slide atual toca.
   ============================================================ */
(function () {
  var overlay, trilho, contador, thumbs, atual = 0, midias = [];

  var DURACAO = 320;            /* VELOCIDADE do deslize (ms) */
  var ESCALA_MIN = 1, ESCALA_MAX = 4, ESCALA_TOQUE = 2.2;

  var escala = 1, tx = 0, ty = 0;

  var pontos = {};
  var distInicial = 0, escalaInicial = 1;
  var pincaX = 0, pincaY = 0, pincaTx = 0, pincaTy = 0;
  var arrX = 0, arrY = 0, arrTx = 0, arrTy = 0;
  var tTempo = 0, tUltimo = 0, tX = 0, tY = 0;
  var arrastandoTrilho = false, trilhoX0 = 0;

  /* ---- coleta fotos E vídeos, na ordem da galeria --------- */
  function coletar() {
    midias = [];
    document.querySelectorAll('.product__media-item').forEach(function (item) {
      if (item.dataset.mediaType === 'video' || item.querySelector('native-video')) {
        var v = item.querySelector('video');
        var fonte = v && v.querySelector('source');
        midias.push({
          tipo: 'video',
          src: fonte ? fonte.src : (v ? v.src : ''),
          poster: v ? v.getAttribute('poster') : ''
        });
      } else {
        var im = item.querySelector('img');
        if (!im) return;
        var s = im.currentSrc || im.src;
        midias.push({ tipo: 'foto', src: s.replace(/(\?|&)width=\d+/, '$1width=2048') });
      }
    });
    return midias.length > 0;
  }

  function itemAtual() { return trilho.children[atual]; }
  function ehVideo(n) { return midias[n] && midias[n].tipo === 'video'; }

  /* ---- TRILHO -------------------------------------------- */

  function moverTrilho(comTransicao, extra) {
    extra = extra || 0;
    trilho.style.transition = comTransicao ? 'transform ' + DURACAO + 'ms cubic-bezier(.22,.61,.36,1)' : 'none';
    trilho.style.transform = 'translateX(' + (-atual * 100 + extra) + '%)';
  }

  /* toca só o slide atual, pausa os demais */
  function ajustarVideos() {
    [].forEach.call(trilho.children, function (el, n) {
      if (el.tagName !== 'VIDEO') return;
      if (n === atual) {
        var p = el.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        el.pause();
        el.currentTime = 0;
      }
    });
  }

  /* ---- ZOOM (só em foto) --------------------------------- */

  function aplicarZoom(comTransicao) {
    var el = itemAtual();
    if (!el) return;
    el.style.transition = comTransicao ? 'transform .25s ease' : 'none';
    el.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + escala + ')';
    overlay.classList.toggle('is-zoom', escala > 1.01);
  }

  function limitar() {
    var el = itemAtual();
    if (!el || escala <= 1) { tx = 0; ty = 0; return; }
    var maxX = Math.max(0, (el.offsetWidth * escala - window.innerWidth) / 2);
    var maxY = Math.max(0, (el.offsetHeight * escala - window.innerHeight) / 2);
    tx = Math.max(-maxX, Math.min(maxX, tx));
    ty = Math.max(-maxY, Math.min(maxY, ty));
  }

  function zerarZoom(comTransicao) {
    escala = 1; tx = 0; ty = 0;
    var el = itemAtual();
    if (el) {
      el.style.transition = comTransicao !== false ? 'transform .25s ease' : 'none';
      el.style.transform = '';
    }
    overlay.classList.remove('is-zoom');
  }

  function ampliarEm(x, y, novaEscala) {
    var el = itemAtual();
    if (!el) return;
    var r = el.getBoundingClientRect();
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    var fator = novaEscala / escala;

    tx = (tx - (x - cx)) * fator + (x - cx);
    ty = (ty - (y - cy)) * fator + (y - cy);
    escala = novaEscala;

    limitar();
    aplicarZoom(true);
  }

  /* ---- MONTAGEM ------------------------------------------ */

  function montar() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'urza-lightbox';
    overlay.innerHTML =
      '<button class="urza-lb__fechar" aria-label="Fechar">&times;</button>' +
      '<button class="urza-lb__seta urza-lb__seta--ant" aria-label="Anterior">&#10094;</button>' +
      '<div class="urza-lb__palco"><div class="urza-lb__trilho"></div></div>' +
      '<button class="urza-lb__seta urza-lb__seta--prox" aria-label="Próxima">&#10095;</button>' +
      '<span class="urza-lb__contador"></span>' +
      '<div class="urza-lb__thumbs"></div>';
    document.body.appendChild(overlay);

    trilho = overlay.querySelector('.urza-lb__trilho');
    contador = overlay.querySelector('.urza-lb__contador');
    thumbs = overlay.querySelector('.urza-lb__thumbs');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('urza-lb__palco')) fechar();
    });
    overlay.querySelector('.urza-lb__fechar').addEventListener('click', fechar);
    overlay.querySelector('.urza-lb__seta--ant').addEventListener('click', function () { ir(-1); });
    overlay.querySelector('.urza-lb__seta--prox').addEventListener('click', function () { ir(1); });

    /* ---- DESKTOP ---- */
    trilho.addEventListener('click', function (e) {
      if ('ontouchstart' in window) return;

      if (e.target.tagName === 'VIDEO') {
        if (e.target.paused) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
        return;
      }
      if (!e.target.classList.contains('urza-lb__img')) return;
      if (escala > 1.01) zerarZoom();
      else ampliarEm(e.clientX, e.clientY, ESCALA_TOQUE);
    });

    /* ---- MOBILE ---- */

    trilho.addEventListener('touchstart', function (e) {
      [].forEach.call(e.changedTouches, function (t) {
        pontos[t.identifier] = { x: t.clientX, y: t.clientY };
      });

      var ids = Object.keys(pontos);

      if (ids.length === 2) {
        var a = pontos[ids[0]], b = pontos[ids[1]];
        distInicial = Math.hypot(b.x - a.x, b.y - a.y);
        escalaInicial = escala;
        pincaX = (a.x + b.x) / 2;
        pincaY = (a.y + b.y) / 2;
        pincaTx = tx;
        pincaTy = ty;
        arrastandoTrilho = false;
      } else if (ids.length === 1) {
        var t = e.changedTouches[0];
        tX = t.clientX; tY = t.clientY; tTempo = Date.now();
        arrX = t.clientX; arrY = t.clientY;
        arrTx = tx; arrTy = ty;
        trilhoX0 = t.clientX;
        arrastandoTrilho = (escala <= 1.01);
      }
    }, { passive: true });

    trilho.addEventListener('touchmove', function (e) {
      [].forEach.call(e.changedTouches, function (t) {
        if (pontos[t.identifier]) { pontos[t.identifier].x = t.clientX; pontos[t.identifier].y = t.clientY; }
      });

      var ids = Object.keys(pontos);

      if (ids.length === 2) {
        e.preventDefault();
        var a = pontos[ids[0]], b = pontos[ids[1]];
        var dist = Math.hypot(b.x - a.x, b.y - a.y);
        if (distInicial > 0) {
          var nova = Math.max(ESCALA_MIN, Math.min(ESCALA_MAX, escalaInicial * (dist / distInicial)));
          var el = itemAtual();
          var r = el.getBoundingClientRect();
          var cx = r.left + r.width / 2 - tx;
          var cy = r.top + r.height / 2 - ty;
          var fator = nova / escalaInicial;

          tx = (pincaTx - (pincaX - cx)) * fator + (pincaX - cx);
          ty = (pincaTy - (pincaY - cy)) * fator + (pincaY - cy);
          escala = nova;

          limitar();
          aplicarZoom(false);
        }
      } else if (ids.length === 1 && escala > 1.01) {
        e.preventDefault();
        var t1 = e.changedTouches[0];
        tx = arrTx + (t1.clientX - arrX);
        ty = arrTy + (t1.clientY - arrY);
        limitar();
        aplicarZoom(false);
      } else if (ids.length === 1 && arrastandoTrilho) {
        var t2 = e.changedTouches[0];
        var dx = t2.clientX - trilhoX0;
        var dy = t2.clientY - tY;
        if (Math.abs(dx) > Math.abs(dy)) {
          e.preventDefault();
          moverTrilho(false, (dx / window.innerWidth) * 100);
        }
      }
    }, { passive: false });

    trilho.addEventListener('touchend', function (e) {
      [].forEach.call(e.changedTouches, function (t) { delete pontos[t.identifier]; });

      var restantes = Object.keys(pontos).length;
      var t = e.changedTouches[0];
      var dx = t.clientX - tX, dy = t.clientY - tY;
      var duracao = Date.now() - tTempo;

      if (restantes === 0 && escala <= 1.01 && !arrastandoTrilho) zerarZoom();

      if (restantes > 0) {
        var ids2 = Object.keys(pontos);
        var p0 = pontos[ids2[0]];
        arrX = p0.x; arrY = p0.y;
        arrTx = tx; arrTy = ty;
        distInicial = 0;
        return;
      }

      distInicial = 0;

      var foiToque = Math.abs(dx) < 12 && Math.abs(dy) < 12 && duracao < 400;

      if (foiToque) {
        /* VÍDEO: toque simples dá play/pause, sem esperar duplo toque.
           O zoom no vídeo é só por pinça. */
        if (ehVideo(atual)) {
          e.preventDefault();
          var v = itemAtual();
          if (v.paused) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
          else v.pause();
          arrastandoTrilho = false;
          return;
        }

        var agora = Date.now();
        if (agora - tUltimo < 300) {
          e.preventDefault();
          if (escala > 1.01) zerarZoom();
          else ampliarEm(t.clientX, t.clientY, ESCALA_TOQUE);
          tUltimo = 0;
        } else {
          tUltimo = agora;
        }
        arrastandoTrilho = false;
        return;
      }

      if (arrastandoTrilho) {
        arrastandoTrilho = false;
        var limite = window.innerWidth * 0.2;
        if (dx < -limite && atual < midias.length - 1) ir(1);
        else if (dx > limite && atual > 0) ir(-1);
        else moverTrilho(true);
      }
    }, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-aberto')) return;
      if (e.key === 'Escape') fechar();
      if (e.key === 'ArrowLeft') ir(-1);
      if (e.key === 'ArrowRight') ir(1);
    });
  }

  /* ---- CONSTRUÇÃO ---------------------------------------- */

  function construir() {
    trilho.innerHTML = '';
    midias.forEach(function (m) {
      if (m.tipo === 'video') {
        var v = document.createElement('video');
        v.className = 'urza-lb__video';
        v.src = m.src;
        if (m.poster) v.poster = m.poster;
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'metadata');
        trilho.appendChild(v);
      } else {
        var im = document.createElement('img');
        im.className = 'urza-lb__img';
        im.src = m.src;
        im.alt = '';
        trilho.appendChild(im);
      }
    });

    thumbs.innerHTML = '';
    midias.forEach(function (m, n) {
      var t = document.createElement('img');
      t.className = 'urza-lb__thumb' + (m.tipo === 'video' ? ' is-video' : '');
      t.src = m.tipo === 'video' ? (m.poster || '') : m.src.replace(/width=\d+/, 'width=160');
      t.addEventListener('click', function (e) {
        e.stopPropagation();
        if (n === atual) return;
        zerarZoom(false);
        atual = n;
        moverTrilho(true);
        sincronizar();
      });
      thumbs.appendChild(t);
    });
  }

  function sincronizar() {
    contador.textContent = (atual + 1) + ' / ' + midias.length;
    [].forEach.call(thumbs.children, function (t, n) {
      t.classList.toggle('is-atual', n === atual);
    });
    var ativa = thumbs.children[atual];
    if (ativa && ativa.scrollIntoView) {
      ativa.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    overlay.classList.toggle('is-video', ehVideo(atual));
    ajustarVideos();
  }

  function ir(passo) {
    var novo = atual + passo;
    if (novo < 0 || novo > midias.length - 1) { moverTrilho(true); return; }
    zerarZoom(false);
    atual = novo;
    moverTrilho(true);
    sincronizar();
  }

  function abrir(n) {
    if (!coletar()) return;
    montar();
    construir();
    atual = n;
    zerarZoom(false);
    moverTrilho(false);
    sincronizar();
    overlay.classList.add('is-aberto');
    document.body.style.overflow = 'hidden';
  }

  function fechar() {
    [].forEach.call(trilho.children, function (el) {
      if (el.tagName === 'VIDEO') el.pause();
    });
    overlay.classList.remove('is-aberto');
    overlay.classList.remove('is-zoom');
    document.body.style.overflow = '';
  }

  function ligar() {
    document.querySelectorAll('.product__media-item').forEach(function (item) {
      if (item.dataset.urzaLb) return;
      item.dataset.urzaLb = '1';
      item.style.cursor = 'zoom-in';

      /* índice entre TODAS as mídias (foto e vídeo) */
      var indice = [].indexOf.call(document.querySelectorAll('.product__media-item'), item);

      item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        abrir(indice);
      }, true);
    });
  }

  ligar();
  new MutationObserver(ligar).observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   3. SELOS SOBRE A GALERIA
   ============================================================ */
(function () {
  function posicionar() {
    var selos = document.querySelector('.urza-selos');
    var media = document.querySelector('product-media.product__media');
    if (!selos || !media) return;
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    if (selos.parentElement !== media) media.appendChild(selos);

    /* só revela depois que a primeira foto carregou: antes disso a
       caixa da galeria ainda muda de tamanho e os selos dançam */
    if (selos.dataset.urzaPronto) return;
    var foto = media.querySelector('.product__media-item img');
    if (!foto) return;

    var revelar = function () {
      selos.dataset.urzaPronto = '1';
      selos.classList.add('is-pronto');
    };

    if (foto.complete && foto.naturalWidth > 0) revelar();
    else foto.addEventListener('load', revelar, { once: true });
  }

  function ligar() {
    posicionar();
    document.querySelectorAll('.urza-selo').forEach(function (btn) {
      if (btn.dataset.urzaSelo) return;
      btn.dataset.urzaSelo = '1';
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var aberto = btn.getAttribute('aria-expanded') === 'true';
        var havia = document.querySelector('.urza-selo[aria-expanded="true"]');

        document.querySelectorAll('.urza-selo').forEach(function (o) {
          o.setAttribute('aria-expanded', 'false');
        });

        if (aberto) return;

        if (havia && havia !== btn) {
          setTimeout(function () { btn.setAttribute('aria-expanded', 'true'); }, 100);
        } else {
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.addEventListener('click', function () {
    document.querySelectorAll('.urza-selo[aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
  });

  ligar();
  new MutationObserver(ligar).observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   4. ÍCONE PIX NO RODAPÉ
   ============================================================ */
(function () {
  var PIX_SVG = '<svg class="urza-pix" role="img" viewBox="4 6 54 27" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Pix</title><path d="M56.9235 38.371H5.02946C3.80156 38.3697 2.62432 37.8814 1.75597 37.0132C0.887613 36.1451 0.399049 34.9679 0.397461 33.74V4.632C0.399312 3.40409 0.887928 2.227 1.7562 1.35873C2.62446 0.490467 3.80155 0.00185146 5.02946 0H56.9295C58.1574 0.00158812 59.3345 0.490152 60.2027 1.35851C61.0708 2.22686 61.5591 3.4041 61.5605 4.632V33.74C61.5591 34.9689 61.07 36.1469 60.2005 37.0153C59.331 37.8836 58.1523 38.3713 56.9235 38.371ZM5.02347 0.391006C3.89901 0.392066 2.82091 0.839226 2.0258 1.63434C1.23069 2.42945 0.78353 3.50755 0.782471 4.632V33.74C0.784059 34.8641 1.23145 35.9417 2.0265 36.7364C2.82156 37.5311 3.89936 37.9779 5.02347 37.979H56.9235C58.0473 37.9777 59.1248 37.5306 59.9194 36.736C60.7141 35.9413 61.1612 34.8639 61.1625 33.74V4.632C61.1617 3.50781 60.7149 2.42986 59.9201 1.63475C59.1254 0.839638 58.0477 0.392331 56.9235 0.391006H5.02347Z" fill="black"/><path d="M27.2943 25.952C27.2242 25.952 27.1571 25.9242 27.1076 25.8747C27.0581 25.8252 27.0303 25.758 27.0303 25.688V17.088C27.0311 16.2587 27.3609 15.4635 27.9473 14.8771C28.5338 14.2906 29.3289 13.9608 30.1583 13.96H32.6963C33.5234 13.9629 34.3158 14.2933 34.8999 14.879C35.4841 15.4646 35.8125 16.2578 35.8133 17.085V18.913C35.8127 19.7424 35.483 20.5378 34.8965 21.1243C34.31 21.7108 33.5147 22.0405 32.6853 22.041H29.1003C29.0643 22.0432 29.0282 22.0381 28.9944 22.0258C28.9605 22.0136 28.9294 21.9945 28.9032 21.9698C28.8769 21.9452 28.856 21.9154 28.8417 21.8823C28.8274 21.8492 28.82 21.8135 28.82 21.7775C28.82 21.7415 28.8274 21.7058 28.8417 21.6727C28.856 21.6397 28.8769 21.6099 28.9032 21.5852C28.9294 21.5605 28.9605 21.5414 28.9944 21.5292C29.0282 21.517 29.0643 21.5118 29.1003 21.514H32.6853C33.3748 21.514 34.0361 21.2401 34.5237 20.7525C35.0113 20.2649 35.2853 19.6036 35.2853 18.914V17.086C35.2853 16.3985 35.013 15.739 34.528 15.2518C34.043 14.7645 33.3847 14.4892 32.6973 14.486H30.1593C29.4697 14.486 28.8084 14.7599 28.3208 15.2475C27.8332 15.7351 27.5593 16.3965 27.5593 17.086V25.686C27.5595 25.7209 27.5529 25.7556 27.5397 25.7879C27.5264 25.8202 27.5069 25.8496 27.4823 25.8743C27.4577 25.8991 27.4283 25.9187 27.3961 25.932C27.3638 25.9453 27.3292 25.9521 27.2943 25.952ZM38.5353 22.087C38.5006 22.0871 38.4662 22.0804 38.4341 22.0672C38.402 22.054 38.3728 22.0345 38.3483 22.01C38.3238 21.9854 38.3043 21.9563 38.2911 21.9242C38.2779 21.8921 38.2711 21.8577 38.2713 21.823V15.398C38.271 15.1565 38.1749 14.9249 38.0042 14.7541C37.8334 14.5833 37.6018 14.4873 37.3603 14.487H36.2603C36.1901 14.487 36.1228 14.4591 36.0732 14.4095C36.0236 14.3599 35.9958 14.2927 35.9958 14.2225C35.9958 14.1524 36.0236 14.0851 36.0732 14.0355C36.1228 13.9859 36.1901 13.958 36.2603 13.958H37.3603C37.7417 13.9588 38.1074 14.1108 38.3769 14.3808C38.6465 14.6507 38.798 15.0165 38.7983 15.398V21.819C38.7988 21.8539 38.7924 21.8885 38.7794 21.9209C38.7664 21.9533 38.7471 21.9827 38.7227 22.0076C38.6982 22.0324 38.669 22.0521 38.6368 22.0656C38.6047 22.0791 38.5701 22.086 38.5353 22.086V22.087Z" fill="black"/><path d="M38.2998 13.2312L37.7998 12.7312C37.7404 12.6716 37.707 12.5909 37.707 12.5067C37.707 12.4226 37.7404 12.3418 37.7998 12.2822L38.2998 11.7822C38.3594 11.7228 38.4401 11.6895 38.5243 11.6895C38.6085 11.6895 38.6892 11.7228 38.7488 11.7822L39.2488 12.2822C39.3082 12.3418 39.3416 12.4226 39.3416 12.5067C39.3416 12.5909 39.3082 12.6716 39.2488 12.7312L38.7488 13.2312C38.6892 13.2906 38.6085 13.324 38.5243 13.324C38.4401 13.324 38.3594 13.2906 38.2998 13.2312Z" fill="black"/><path d="M41.7395 22.0311H40.6475C40.5773 22.0311 40.51 22.0032 40.4604 21.9536C40.4108 21.904 40.3829 21.8367 40.3829 21.7666C40.3829 21.6964 40.4108 21.6291 40.4604 21.5795C40.51 21.5299 40.5773 21.5021 40.6475 21.5021H41.7395C42.2308 21.5003 42.7018 21.3053 43.0505 20.9591L45.6015 18.4051C45.8101 18.1961 46.0932 18.0785 46.3885 18.0781C46.5346 18.0776 46.6794 18.1063 46.8144 18.1625C46.9493 18.2186 47.0717 18.3011 47.1745 18.4051L49.7175 20.9501C49.8895 21.1222 50.0939 21.2587 50.3189 21.3515C50.5439 21.4443 50.7851 21.4918 51.0285 21.4911H51.9155C51.9856 21.4911 52.0529 21.5189 52.1025 21.5685C52.1521 21.6181 52.18 21.6854 52.18 21.7556C52.18 21.8257 52.1521 21.893 52.1025 21.9426C52.0529 21.9922 51.9856 22.0201 51.9155 22.0201H51.0285C50.7154 22.0208 50.4053 21.9593 50.1162 21.8392C49.8271 21.719 49.5647 21.5425 49.3445 21.3201L46.7995 18.7751C46.6903 18.6655 46.5421 18.6037 46.3875 18.6031C46.3107 18.6032 46.2347 18.6184 46.1638 18.6479C46.093 18.6775 46.0286 18.7207 45.9745 18.7751L43.4255 21.3271C42.9783 21.7748 42.3723 22.0279 41.7395 22.0311ZM46.3885 17.9071C46.2423 17.9075 46.0975 17.8788 45.9625 17.8227C45.8276 17.7665 45.7052 17.6841 45.6025 17.5801L43.0485 15.0261C42.7004 14.6795 42.2296 14.4843 41.7385 14.4831H40.6465C40.6105 14.4853 40.5745 14.4801 40.5406 14.4679C40.5067 14.4556 40.4756 14.4366 40.4494 14.4119C40.4231 14.3872 40.4022 14.3574 40.3879 14.3243C40.3736 14.2913 40.3662 14.2556 40.3662 14.2196C40.3662 14.1835 40.3736 14.1479 40.3879 14.1148C40.4022 14.0817 40.4231 14.0519 40.4494 14.0272C40.4756 14.0025 40.5067 13.9835 40.5406 13.9713C40.5745 13.959 40.6105 13.9538 40.6465 13.9561H41.7385C42.3704 13.9585 42.9759 14.21 43.4235 14.6561L45.9755 17.2101C46.0847 17.3194 46.2329 17.3809 46.3875 17.3811C46.5413 17.3804 46.6887 17.3189 46.7975 17.2101L49.3435 14.6651C49.5638 14.4427 49.8262 14.2663 50.1152 14.1461C50.4043 14.026 50.7144 13.9644 51.0275 13.9651H51.9145C51.9846 13.9651 52.0519 13.9929 52.1015 14.0425C52.1511 14.0921 52.179 14.1594 52.179 14.2296C52.179 14.2997 52.1511 14.367 52.1015 14.4166C52.0519 14.4662 51.9846 14.4941 51.9145 14.4941H51.0275C50.7839 14.4935 50.5426 14.5411 50.3176 14.6343C50.0926 14.7275 49.8883 14.8644 49.7165 15.0371L47.1715 17.5821C47.0693 17.6862 46.9472 17.7688 46.8126 17.8249C46.6779 17.8811 46.5333 17.9097 46.3875 17.9091L46.3885 17.9071Z" fill="black"/><path d="M20.7866 23.398C20.517 23.399 20.25 23.3464 20.0009 23.2434C19.7518 23.1404 19.5257 22.989 19.3356 22.798L17.2416 20.704C17.1672 20.6334 17.0686 20.594 16.966 20.594C16.8635 20.594 16.7649 20.6334 16.6906 20.704L14.5906 22.804C14.4 22.9948 14.1737 23.146 13.9245 23.249C13.6753 23.352 13.4082 23.4046 13.1385 23.404H12.7266L15.3796 26.057C15.7775 26.4546 16.317 26.678 16.8796 26.678C17.4421 26.678 17.9816 26.4546 18.3796 26.057L21.0396 23.397L20.7866 23.398Z" fill="black"/><path d="M13.1376 15.9881C13.4072 15.9872 13.6742 16.0397 13.9232 16.1427C14.1723 16.2457 14.3985 16.3971 14.5886 16.5881L16.6886 18.6881C16.762 18.7606 16.861 18.8012 16.9641 18.8012C17.0673 18.8012 17.1663 18.7606 17.2396 18.6881L19.3336 16.5881C19.5238 16.397 19.7499 16.2456 19.999 16.1427C20.2481 16.0397 20.5151 15.9871 20.7846 15.9881H21.0366L18.3766 13.3281C17.9787 12.9304 17.4392 12.707 16.8766 12.707C16.3141 12.707 15.7745 12.9304 15.3766 13.3281L12.7236 15.9811L13.1376 15.9881Z" fill="black"/><path d="M23.241 18.1949L21.632 16.5879C21.5959 16.6029 21.5571 16.6107 21.518 16.6109H20.787C20.4071 16.6119 20.0428 16.7624 19.773 17.0299L17.673 19.1299C17.58 19.2238 17.4694 19.2983 17.3474 19.3492C17.2255 19.4 17.0946 19.4262 16.9625 19.4262C16.8304 19.4262 16.6996 19.4 16.5776 19.3492C16.4557 19.2983 16.345 19.2238 16.252 19.1299L14.152 17.0299C13.8814 16.7623 13.5165 16.6118 13.136 16.6109H12.236C12.199 16.6099 12.1624 16.6025 12.128 16.5889L10.515 18.2019C10.318 18.3989 10.1617 18.6327 10.0551 18.8901C9.94844 19.1474 9.89355 19.4233 9.89355 19.7019C9.89355 19.9805 9.94844 20.2563 10.0551 20.5137C10.1617 20.7711 10.318 21.0049 10.515 21.2019L12.128 22.8149C12.1624 22.8013 12.199 22.7939 12.236 22.7929H13.136C13.5169 22.792 13.8821 22.6407 14.152 22.3719L16.252 20.2719C16.4435 20.0886 16.6984 19.9863 16.9635 19.9863C17.2286 19.9863 17.4835 20.0886 17.675 20.2719L19.775 22.3719C20.0448 22.6393 20.4091 22.7899 20.789 22.7909H21.52C21.5591 22.7911 21.5979 22.7989 21.634 22.8139L23.243 21.2069C23.6402 20.8087 23.8632 20.2693 23.8632 19.7069C23.8632 19.1445 23.6402 18.6051 23.243 18.2069L23.241 18.1949Z" fill="black"/></svg>';

  function inserirPix() {
    var lista = document.querySelector('.payment-methods-list');
    if (!lista || lista.querySelector('.urza-pix')) return;

    var wrap = document.createElement('div');
    wrap.innerHTML = PIX_SVG;
    lista.insertBefore(wrap.firstChild, lista.firstChild);
  }

  inserirPix();
  new MutationObserver(inserirPix).observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   5. BOTÃO "CONTINUAR COMPRANDO" NO CARRINHO
   ============================================================ */
(function () {
  function inserir() {
    var footer = document.querySelector('.mini-cart__drawer-footer');
    if (!footer || footer.querySelector('.urza-continuar')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'urza-continuar';
    btn.textContent = 'Continuar comprando';
    btn.addEventListener('click', function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.removeAttribute('open');
    });

    footer.appendChild(btn);
  }

  inserir();
  new MutationObserver(inserir).observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   6. FAVORITOS — ÍCONE NO HEADER + DRAWER
   ============================================================ */
(function () {
  var CHAVE = 'urza:favoritos';
  var drawer;
  var cache = {};

  function lista() {
    try { return JSON.parse(localStorage.getItem(CHAVE)) || []; }
    catch (e) { return []; }
  }

  /* pre-carrega os dados dos favoritos ao passar o mouse / tocar no icone */
  function prefetch() {
    lista().slice(0, 12).forEach(function (h) {
      if (cache[h]) return;
      cache[h] = fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    });
  }

  function atualizar() {
    var el = document.getElementById('urza-fav-count');
    if (!el) return;
    var n = lista().length;
    el.textContent = n;
    el.style.display = n === 0 ? 'none' : '';
  }

  function montarIcone() {
    if (document.querySelector('.urza-fav-link')) return true;

    var carrinho = document.querySelector('.header__cart-icon, a[href*="/cart"]');
    if (!carrinho || !carrinho.parentElement) return false;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'urza-fav-link header__icon-wrapper tap-area';
    btn.setAttribute('aria-label', 'Meus favoritos');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M12 21s-7.5-4.9-10-9.6C.5 8 2.5 4.5 6 4.5c2.1 0 3.6 1.2 4.5 2.6' +
      'l1.5 2.2 1.5-2.2c.9-1.4 2.4-2.6 4.5-2.6 3.5 0 5.5 3.5 4 6.9' +
      'C19.5 16.1 12 21 12 21z"/></svg>' +
      '<span id="urza-fav-count" class="header__cart-count header__cart-count--floating bubble-count">0</span>';

    btn.addEventListener('click', abrirDrawer);
    btn.addEventListener('mouseenter', prefetch);
    btn.addEventListener('touchstart', prefetch, { passive: true });
    carrinho.parentElement.insertBefore(btn, carrinho);
    atualizar();
    return true;
  }

  function montarDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'urza-fav-drawer';
    drawer.innerHTML =
      '<div class="urza-fav-drawer__overlay"></div>' +
      '<aside class="urza-fav-drawer__painel">' +
      '  <header class="urza-fav-drawer__topo">' +
      '    <span class="urza-fav-drawer__titulo">Meus favoritos</span>' +
      '    <button type="button" class="urza-fav-drawer__fechar" aria-label="Fechar">&times;</button>' +
      '  </header>' +
      '  <div class="urza-fav-drawer__corpo"></div>' +
      '</aside>';
    document.body.appendChild(drawer);

    drawer.querySelector('.urza-fav-drawer__overlay').addEventListener('click', fecharDrawer);
    drawer.querySelector('.urza-fav-drawer__fechar').addEventListener('click', fecharDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fecharDrawer();
    });
  }

  function abrirDrawer() {
    montarDrawer();
    document.body.style.overflow = 'hidden';
    carregar();
    drawer.classList.add('is-aberto');
  }

  function fecharDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-aberto');
    document.body.style.overflow = '';
  }

  function carregar() {
    var corpo = drawer.querySelector('.urza-fav-drawer__corpo');
    var handles = lista();

    if (!handles.length) {
      corpo.innerHTML = '<p class="urza-fav-vazio">Você ainda não salvou nenhuma peça.</p>';
      return;
    }

    corpo.innerHTML = '';

    prefetch();
    Promise.all(handles.map(function (h) { return cache[h]; })).then(function (produtos) {
      var html = produtos.filter(Boolean).map(function (p) {
        var img = p.featured_image
          ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2')
          : '';

        var opcoes = p.variants.map(function (v) {
          return '<button type="button" class="urza-fav-tam' +
            (v.available ? '' : ' is-esgotado') + '"' +
            (v.available ? '' : ' disabled') +
            ' data-id="' + v.id + '" data-titulo="' + v.title + '">' + v.title + '</button>';
        }).join('');

        return '<div class="urza-fav-item" data-handle="' + p.handle + '">' +
          '<div class="urza-fav-item__linha">' +
          '<a href="/products/' + p.handle + '" class="urza-fav-item__img">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<div class="urza-fav-item__info">' +
          '  <a href="/products/' + p.handle + '" class="urza-fav-item__titulo">' + p.title + '</a>' +
          '  <span class="urza-fav-item__preco">' +
               (p.price / 100).toFixed(2).replace('.', ',') + '</span>' +
          '</div>' +
          '<button type="button" class="urza-fav-item__add" aria-label="Adicionar ao carrinho">' +
          '  <svg viewBox="0 0 21 20" width="19" height="18" fill="none" stroke="currentColor" stroke-width="1.5">' +
          '    <path d="M0 1H4L5 11H17L19 4H6"/><circle cx="7" cy="16" r="1.5"/><circle cx="15" cy="16" r="1.5"/>' +
          '  </svg>' +
          '</button>' +
          '<button type="button" class="urza-fav-item__remover" aria-label="Remover">&times;</button>' +
          '</div>' +
          '<div class="urza-fav-item__tamanhos">' + opcoes + '</div>' +
          '</div>';
      }).join('');

      corpo.innerHTML = html || '<p class="urza-fav-vazio">Nenhuma peça disponível.</p>';

      /* animacao de entrada: estado inicial, reflow, depois libera */
      corpo.querySelectorAll('.urza-fav-item').forEach(function (el) {
        el.style.opacity = '0';
        el.style.transform = 'translateX(80px)';   /* DISTANCIA da entrada lateral */
      });
      void corpo.offsetWidth;
      corpo.querySelectorAll('.urza-fav-item').forEach(function (el, n) {
        el.style.transitionDelay = (0.05 + n * 0.08) + 's';   /* ATRASO entre itens */
        el.style.opacity = '';
        el.style.transform = '';
      });

      corpo.querySelectorAll('.urza-fav-item__remover').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.urza-fav-item');
          var h = item.dataset.handle;
          var l = lista();
          var i = l.indexOf(h);
          if (i !== -1) l.splice(i, 1);
          localStorage.setItem(CHAVE, JSON.stringify(l));
          item.remove();
          atualizar();
          document.dispatchEvent(new CustomEvent('urza:favoritos-mudou'));
          if (!lista().length) carregar();
        });
      });

      corpo.querySelectorAll('.urza-fav-item__add').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.urza-fav-item');
          corpo.querySelectorAll('.urza-fav-item').forEach(function (o) {
            if (o !== item) o.classList.remove('is-escolhendo');
          });
          item.classList.toggle('is-escolhendo');
        });
      });

      corpo.querySelectorAll('.urza-fav-tam').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.urza-fav-item');
          btn.disabled = true;
          btn.textContent = '…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(btn.dataset.id), quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error();
            item.classList.remove('is-escolhendo');
            btn.disabled = false;
            btn.textContent = btn.dataset.titulo;
            fecharDrawer();
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { replacementDelay: 750 }
            }));
            setTimeout(function () {
              var c = document.querySelector('cart-drawer');
              if (c) c.setAttribute('open', '');
            }, 500);
          }).catch(function () {
            btn.disabled = false;
            btn.textContent = 'Erro';
          });
        });
      });
    });
  }

  function iniciar() {
    if (montarIcone()) return;
    var tentativas = 0;
    var t = setInterval(function () {
      if (montarIcone() || ++tentativas > 60) clearInterval(t);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  window.addEventListener('pageshow', iniciar);
  window.addEventListener('storage', atualizar);
  document.addEventListener('urza:favoritos-mudou', atualizar);
})();


/* ============================================================
   7. CUPOM E TOTAIS NO CARRINHO
   ============================================================ */
(function () {
  function moeda(centavos) {
    return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
  }

  function montar() {
    var footer = document.querySelector('.mini-cart__drawer-footer');
    if (!footer || footer.querySelector('.urza-cupom')) return;

    var bloco = document.createElement('div');
    bloco.className = 'urza-resumo';
    bloco.innerHTML =
      '<details class="urza-cupom">' +
      '  <summary class="urza-cupom__topo">' +
      '    <span class="urza-cupom__titulo">Cupom de desconto</span>' +
      '    <span class="urza-cupom__acao">Aplicar cupom' +
      '      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 6 8 10 12 6"/></svg>' +
      '    </span>' +
      '  </summary>' +
      '  <div class="urza-cupom__corpo">' +
      '    <div class="urza-cupom__erro" hidden></div>' +
      '    <form class="urza-cupom__form">' +
      '      <input type="text" class="urza-cupom__input" placeholder="Código do desconto" required>' +
      '      <button type="submit" class="urza-cupom__botao">Aplicar</button>' +
      '    </form>' +
      '  </div>' +
      '</details>' +
      '<div class="urza-cupom__aplicados"></div>' +
      '<div class="urza-total urza-total--sub"><span>Subtotal:</span><span data-sub></span></div>' +
      '<div class="urza-total urza-total--desc" hidden><span>Descontos (Cupom):</span><span data-desc></span></div>' +
      '<div class="urza-total urza-total--final"><span>Total:</span><span data-final></span></div>';

    var acoes = footer.querySelector('.mini-cart__actions');
    footer.insertBefore(bloco, acoes ? acoes.nextSibling : footer.firstChild);

    bloco.querySelector('.urza-cupom__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = bloco.querySelector('.urza-cupom__input');
      var codigo = input.value.trim();
      if (!codigo) return;
      aplicar(codigo, bloco);
    });

    atualizar();
  }

  function codigosAtuais(cart) {
    return (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; });
  }

  function aplicar(codigo, bloco) {
    var btn = bloco.querySelector('.urza-cupom__botao');
    var erro = bloco.querySelector('.urza-cupom__erro');
    btn.disabled = true;
    btn.textContent = '…';
    erro.hidden = true;

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var lista = codigosAtuais(cart);
      if (lista.indexOf(codigo) === -1) lista.push(codigo);
      return enviar(lista);
    }).then(function (cart) {
      btn.disabled = false;
      btn.textContent = 'Aplicar';

      var ok = (cart.discount_codes || []).some(function (d) {
        return d.code.toLowerCase() === codigo.toLowerCase() && d.applicable;
      });

      if (!ok) {
        erro.textContent = 'Cupom inválido ou não aplicável a este carrinho.';
        erro.hidden = false;
        return;
      }

      bloco.querySelector('.urza-cupom__input').value = '';
      bloco.querySelector('.urza-cupom').removeAttribute('open');
      refletir(cart);
      avisarTema(cart);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Aplicar';
      erro.textContent = 'Não foi possível aplicar o cupom. Tente novamente.';
      erro.hidden = false;
    });
  }

  function remover(codigo) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var lista = codigosAtuais(cart).filter(function (c) { return c !== codigo; });
      return enviar(lista);
    }).then(function (cart) {
      refletir(cart);
      avisarTema(cart);
    });
  }

  function enviar(lista) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: lista.join(',') })
    }).then(function (r) { return r.json(); });
  }

  function avisarTema(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart, replacementDelay: 0 }
    }));
    setTimeout(atualizar, 600);
  }

  function refletir(cart) {
    var bloco = document.querySelector('.urza-resumo');
    if (!bloco) return;

    /* cupons digitados pelo cliente */
    var codigos = (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return { code: d.code, automatico: false }; });

    /* descontos automáticos não entram em discount_codes — pega dos itens.
       Comparação em MAIÚSCULAS: "carrinho7" digitado e "CARRINHO7" do
       admin são o mesmo desconto e não podem virar dois chips. */
    var vistos = {};
    codigos.forEach(function (d) { vistos[d.code.toUpperCase()] = true; });
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        if (!d.title) return;
        var chave = d.title.toUpperCase();
        if (vistos[chave]) return;
        vistos[chave] = true;
        codigos.push({ code: d.title, automatico: true });
      });
    });
    var desconto = cart.total_discount || 0;

    bloco.querySelector('[data-sub]').textContent = moeda(cart.original_total_price);
    bloco.querySelector('[data-final]').textContent = moeda(cart.total_price);

    var linhaDesc = bloco.querySelector('.urza-total--desc');
    if (desconto > 0) {
      bloco.querySelector('[data-desc]').textContent = '-' + moeda(desconto);
      linhaDesc.hidden = false;
    } else {
      linhaDesc.hidden = true;
    }

    var alvo = bloco.querySelector('.urza-cupom__aplicados');
    alvo.innerHTML = codigos.map(function (d) {
      return '<span class="urza-cupom__chip">' +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">' +
        '<path fill-rule="evenodd" d="M9.94 1.12A1 1 0 0 0 8.88.06L5.4.26a1 1 0 0 0-.65.29L.71 4.59a1 1 0 0 0 0 1.41l3.29 3.3a1 1 0 0 0 1.41 0l4.04-4.04a1 1 0 0 0 .29-.65l.2-3.49zM7.06 2.94a.83.83 0 1 0 1.17-1.17.83.83 0 0 0-1.17 1.17z"/></svg>' +
        d.code.toUpperCase() +
        (d.automatico ? '' :
          '<button type="button" class="urza-cupom__remover" data-codigo="' + d.code + '" aria-label="Remover cupom">&times;</button>') +
        '</span>';
    }).join('');

    alvo.querySelectorAll('.urza-cupom__remover').forEach(function (b) {
      b.addEventListener('click', function () { remover(b.dataset.codigo); });
    });

    /* fallback: garante o desconto no checkout */
    var form = document.getElementById('mini-cart-form');
    if (form) {
      var antigo = form.querySelector('input[name="discount"]');
      if (antigo) antigo.remove();
      /* só cupons DIGITADOS: descontos automáticos não são códigos
         e dariam "código inválido" no checkout */
      var digitados = codigos.filter(function (d) { return !d.automatico; });
      if (digitados.length) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'discount';
        hidden.value = digitados.map(function (d) { return d.code; }).join(',');
        form.appendChild(hidden);
      }
    }
  }

  function atualizar() {
    montar();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(refletir);
  }

  atualizar();
  new MutationObserver(function () { montar(); }).observe(document.body, { childList: true, subtree: true });
  document.documentElement.addEventListener('cart:refresh', function () {
    setTimeout(atualizar, 700);
  });
})();


/* ============================================================
   8. ESCONDE O WHATSAPP COM A BARRA STICKY DE COMPRA
   ============================================================ */
(function () {
  var barra = document.querySelector('product-sticky-form');
  if (!barra) return;

  var obs = new IntersectionObserver(function (entries) {
    document.body.classList.toggle('urza-sticky-visivel', entries[0].isIntersecting);
  }, { threshold: 0.1 });

  obs.observe(barra);
})();

/* ============================================================
   9. CORAÇÃO DE FAVORITOS NA PÁGINA DE PRODUTO
   ============================================================ */
(function () {
  var CHAVE = 'urza:favoritos';

  function lista() {
    try { return JSON.parse(localStorage.getItem(CHAVE)) || []; }
    catch (e) { return []; }
  }

  function handleAtual() {
    var m = location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1] : null;
  }

  function montar() {
    if (document.querySelector('.urza-fav-produto')) return;

    var handle = handleAtual();
    if (!handle) return;

    /* insere ao lado do bloco de avaliações */
    var alvo = document.querySelector('.product-meta__reference');
    if (!alvo) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'urza-fav-produto';
    btn.setAttribute('aria-label', 'Adicionar aos favoritos');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M12 21s-7.5-4.9-10-9.6C.5 8 2.5 4.5 6 4.5c2.1 0 3.6 1.2 4.5 2.6' +
      'l1.5 2.2 1.5-2.2c.9-1.4 2.4-2.6 4.5-2.6 3.5 0 5.5 3.5 4 6.9' +
      'C19.5 16.1 12 21 12 21z"/></svg>';

    if (lista().indexOf(handle) !== -1) btn.classList.add('ativo');

    btn.addEventListener('click', function () {
      var l = lista();
      var i = l.indexOf(handle);
      if (i === -1) { l.push(handle); btn.classList.add('ativo'); }
      else { l.splice(i, 1); btn.classList.remove('ativo'); }
      localStorage.setItem(CHAVE, JSON.stringify(l));
      document.dispatchEvent(new CustomEvent('urza:favoritos-mudou'));
    });

    alvo.appendChild(btn);
  }

  /* mantém sincronizado se remover pelo drawer */
  document.addEventListener('urza:favoritos-mudou', function () {
    var btn = document.querySelector('.urza-fav-produto');
    if (!btn) return;
    btn.classList.toggle('ativo', lista().indexOf(handleAtual()) !== -1);
  });

  montar();
  new MutationObserver(montar).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   11. SELEÇÃO DE TAMANHO OBRIGATÓRIA
   ------------------------------------------------------------
   PREMISSA: o snippet do variant-picker não traz mais
   checked="checked". Nenhum tamanho vem pré-selecionado, então
   o clique no label marca o radio nativamente e o tema cuida de
   preço e variante. Este bloco só faz:
     A. registrar a escolha do cliente
     B. bloquear o add-to-cart enquanto faltar escolha
     C. guardar/restaurar a escolha no F5 (sessionStorage)
     D. sincronizar a barra sticky (produto simples)
   ============================================================ */
(function () {

  var CHAVE = 'urza:tam:' + ((location.pathname.match(/\/products\/([a-z0-9-]+)/i) || [])[1] || '');
  var escolhido = {};        /* { g0: true } — grupos já escolhidos */
  var restaurando = false;

  /* ---- utilitários ------------------------------------------- */

  function grupos() {
    return document.querySelectorAll('.product-form__option-selector');
  }

  function idDoGrupo(g) {
    if (!g.dataset.urzaTam) g.dataset.urzaTam = 'g' + [].indexOf.call(grupos(), g);
    return g.dataset.urzaTam;
  }

  function radioDoLabel(label) {
    var r = label.previousElementSibling;
    return (r && r.type === 'radio') ? r : null;
  }

  function salvo() {
    try { return JSON.parse(sessionStorage.getItem(CHAVE)) || {}; }
    catch (e) { return {}; }
  }

  function salvar(id, texto) {
    var s = salvo();
    s[id] = texto;
    try { sessionStorage.setItem(CHAVE, JSON.stringify(s)); } catch (e) {}
  }

  /* ---- A. REGISTRAR A ESCOLHA -------------------------------- */

  function registrar(g, texto) {
    var id = idDoGrupo(g);
    escolhido[id] = true;
    g.dataset.urzaEscolhido = '1';     /* o CSS usa isto para revelar o rótulo */
    g.classList.remove('urza-erro');

    /* o rótulo é renderizado pelo CSS a partir deste atributo:
       o que o tema escrever no textContent fica invisível */
    var v = g.querySelector('.product-form__option-value');
    if (v && v.dataset.urzaValor !== texto) v.dataset.urzaValor = texto;

    if (!faltando().length) document.body.classList.add('urza-tam-ok');
  }

  function faltando() {
    var faltam = [];
    grupos().forEach(function (g) {
      if (!escolhido[idDoGrupo(g)]) faltam.push(g);
    });
    return faltam;
  }

  /* ---- B. BLOQUEIO DO ADD-TO-CART ---------------------------- */

  function bloquear(e) {
    var faltam = faltando();
    if (!faltam.length) return;

    e.preventDefault();
    e.stopPropagation();

    faltam.forEach(function (g) { g.classList.add('urza-erro'); });
    faltam[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

    setTimeout(function () {
      faltam.forEach(function (g) { g.classList.remove('urza-erro'); });
    }, 3000);   /* DURAÇÃO do destaque vermelho */
  }

  /* ---- C. BARRA STICKY --------------------------------------- */

  /* o select da sticky vem com uma opção marcada pelo Liquid:
     acrescenta "Tamanho" na frente e deixa ela como atual */
  function prepararSticky() {
    document.querySelectorAll('product-sticky-form select').forEach(function (s) {
      if (s.dataset.urzaSticky) return;
      s.dataset.urzaSticky = '1';

      var vazio = document.createElement('option');
      vazio.value = '';
      vazio.textContent = 'Tamanho';
      s.insertBefore(vazio, s.firstChild);
      s.selectedIndex = 0;

      /* só põe "Tamanho" se ainda não houver escolha —
         senão apaga o tamanho que o cliente acabou de escolher */
      if (faltando().length) {
        var form = s.closest('product-sticky-form');
        var rot = form && form.querySelector('.select__selected-value');
        if (rot && rot.textContent !== 'Tamanho') rot.textContent = 'Tamanho';
      }
    });
  }

  function sincronizarSticky(texto) {
    document.querySelectorAll('product-sticky-form .select__selected-value').forEach(function (rot) {
      if (rot.textContent !== texto) rot.textContent = texto;
    });
    document.querySelectorAll('product-sticky-form select').forEach(function (s) {
      for (var i = 0; i < s.options.length; i++) {
        if (s.options[i].textContent.trim() === texto) { s.selectedIndex = i; break; }
      }
    });
  }

    /* espelha o estado de cada grupo da página no seletor
     correspondente da barra fixa (posição por posição) */
  function espelharSticky() {
    var gs = [].slice.call(grupos());
    document.querySelectorAll('product-sticky-form .select__selected-value').forEach(function (rot, i) {
      var g = gs[i];
      if (!g) return;

      var id = idDoGrupo(g);
      var s = salvo();

      if (escolhido[id] && s[id]) {
        rot.dataset.urzaOk = '1';
        if (rot.textContent !== s[id]) rot.textContent = s[id];
      } else {
        rot.removeAttribute('data-urza-ok');
        if (rot.textContent !== 'Tamanho') rot.textContent = 'Tamanho';
      }
    });
  }

    /* ---- D. ESCOLHA DE TAMANHO (evento do tema) ----------------
     O evento traz option1 E option2 de uma vez. No conjunto, só
     um grupo mudou de fato: compara com previousVariant para
     registrar apenas esse. Sem isso, escolher em cima marcaria
     o de baixo automaticamente.                                */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    var ant = e.detail.previousVariant;

    var lista = [].slice.call(grupos());

    lista.forEach(function (g, n) {
      var campo = 'option' + (n + 1);
      var texto = v[campo];
      if (!texto) return;

      var id = idDoGrupo(g);

      /* quem mudou é quem tem radio marcado: o clique marca o radio
         nativamente, e grupo sem clique não tem nenhum marcado.
         Não dá para comparar com previousVariant — clicar no tamanho
         que já era a variante corrente (o primeiro disponível) não
         muda valor nenhum e o registro seria perdido. */
      var marcado = g.querySelector('.block-swatch__radio:checked, .variant-swatch__radio:checked');
      if (!marcado && !escolhido[id]) return;

      registrar(g, texto);
      salvar(id, texto);

      if (lista.length === 1) sincronizarSticky(texto);
      else espelharSticky();
    });
  });

  /* ---- F. RESTAURAR DEPOIS DO F5 ----------------------------- */
  /* um grupo por passada: no conjunto, o grupo 2 só tem
     disponibilidade real depois que o grupo 1 foi aplicado */
  function restaurar() {
    if (restaurando) return;
    var s = salvo();
    if (!Object.keys(s).length) return;

    var lista = [].slice.call(grupos());
    var pendente = false;

    for (var n = 0; n < lista.length; n++) {
      var g = lista[n];
      var id = idDoGrupo(g);
      var texto = s[id];
      if (!texto || escolhido[id]) continue;

      var achou = null;
      g.querySelectorAll('.block-swatch__item, .variant-swatch__item').forEach(function (el) {
        if (el.textContent.trim() === texto) achou = el;
      });
      if (!achou) continue;

      var sw = achou.closest('.block-swatch, .variant-swatch');
      if (sw && sw.classList.contains('is-disabled')) {
        if (n > 0) pendente = true;   /* espera o grupo anterior */
        continue;                     /* se esgotou de vez, nunca restaura */
      }

      restaurando = true;
      registrar(g, texto);            /* estado ANTES do change */
      var r = radioDoLabel(achou);
      if (r) {
        r.checked = true;
        /* o tema escuta 'change' no radio e emite variant:change */
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
      restaurando = false;

      if (lista.length === 1) sincronizarSticky(texto);

      pendente = true;
      break;
    }

    if (pendente) setTimeout(restaurar, 120);
  }

  /* remarca o radio se o tema reescrever o bloco de variantes.
     GUARDA: só escreve quando não há nada marcado no grupo. */
  function reforcar() {
    var s = salvo();
    grupos().forEach(function (g) {
      var id = idDoGrupo(g);
      if (!escolhido[id] || !s[id]) return;
      if (g.querySelector('.block-swatch__radio:checked, .variant-swatch__radio:checked')) return;

      g.querySelectorAll('.block-swatch__item, .variant-swatch__item').forEach(function (el) {
        if (el.textContent.trim() !== s[id]) return;
        var r = radioDoLabel(el);
        if (r && !r.checked) r.checked = true;
      });
    });
  }

  /* ---- ligação ----------------------------------------------- */

  function ligar() {
    prepararSticky();
    restaurar();
    reforcar();

    espelharSticky();

    document.querySelectorAll('[data-product-add-to-cart-button], .product-form__add-button, product-sticky-form button[type="submit"]').forEach(function (btn) {
      if (btn.dataset.urzaBloqueio) return;
      btn.dataset.urzaBloqueio = '1';
      btn.addEventListener('click', bloquear, true);
    });
  }

  ligar();
  new MutationObserver(ligar).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   13. VÍDEO DA GALERIA COM AUTOPLAY CONTROLADO
   ------------------------------------------------------------
   O Focal guarda o <video> dentro de um <template> e só injeta
   ao clique, deixando a área em branco. Aqui injetamos no load,
   mostramos o poster parado, e só damos play quando o vídeo
   ocupa quase toda a tela (no mobile a galeria mostra um pedaço
   da mídia seguinte — sem isso ele tocaria fora de foco).
   ============================================================ */
(function () {

  var VISIVEL = 0.9;   /* fração do vídeo na tela para começar a tocar */

  function hidratar() {
    document.querySelectorAll('native-video').forEach(function (nv) {
      if (nv.dataset.urzaVideo) return;

      var tpl = nv.querySelector('template');
      if (!tpl) return;

      nv.dataset.urzaVideo = '1';

      /* tira o conteúdo do template e põe no DOM de verdade */
      nv.appendChild(tpl.content.cloneNode(true));
      tpl.remove();

      var v = nv.querySelector('video');
      if (!v) return;

      /* garantias para o autoplay não ser bloqueado pelo navegador */
      v.muted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');

      v.removeAttribute('controls');           /* COMENTE para mostrar os controles */
      v.setAttribute('preload', 'metadata');   /* carrega o poster sem baixar tudo */
      v.removeAttribute('autoplay');           /* quem manda no play é o observer */

      /* só toca quando estiver quase todo visível */
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: VISIVEL });

      obs.observe(v);

    });
  }

  hidratar();
  new MutationObserver(hidratar).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   14. DEPOIMENTOS — RISQUINHOS COM TEMPO + SETAS
   ------------------------------------------------------------
   Usa os elementos do tema (setas e bolinhas). Aqui só:
   - junta setas e risquinhos numa linha (layout no CSS 21)
   - o risquinho ativo enche em INTERVALO; ao encher, avança
   - pausa com mouse em cima, toque, ou seção fora da tela
   ============================================================ */
(function () {

  var INTERVALO = 5000;   /* TEMPO de cada depoimento (ms) */

  var reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciar(tl) {
    if (tl.dataset.urzaDepo) return;
    var dotsNav = tl.querySelector('.testimonial-list__dots');
    var setas = tl.querySelector('.testimonial-list__prev-next-buttons');
    if (!dotsNav) return;
    tl.dataset.urzaDepo = '1';

    tl.style.setProperty('--urza-depo-tempo', INTERVALO + 'ms');

    /* setas + risquinhos no mesmo contêiner */
    var nav = document.createElement('div');
    nav.className = 'urza-depo-nav';
    var ref = setas || dotsNav;
    ref.parentNode.insertBefore(nav, ref);
    if (setas) nav.appendChild(setas);
    nav.appendChild(dotsNav);

    if (reduzido) return;

    function ativo() {
      var d = dotsNav.querySelectorAll('.dots-nav__item');
      for (var i = 0; i < d.length; i++) if (d[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    }

    /* terminou de encher → próximo (volta ao primeiro no fim) */
    dotsNav.addEventListener('animationend', function (e) {
      if (e.animationName !== 'urzaEnche') return;
      var d = dotsNav.querySelectorAll('.dots-nav__item');
      d[(ativo() + 1) % d.length].click();
    });

    new IntersectionObserver(function (e) {
      tl.classList.toggle('urza-fora', !e[0].isIntersecting);
    }, { threshold: 0.3 }).observe(tl);
  }

  function procurar() {
    document.querySelectorAll('testimonial-list').forEach(iniciar);
  }

  procurar();
  new MutationObserver(procurar).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   15. BANNER PRINCIPAL — TROCA LATERAL COM ARRASTO
   ------------------------------------------------------------
   O TEMA comanda: tempo (painel → Auto rotate), barrinha que
   enche e clique nas barrinhas. Aqui só o que ele não faz:
   - desliza a faixa quando o tema troca de slide
   - avisa o tema quando o cliente arrasta
   - barrinha muda já durante o arrasto
   - pausa o relógio com o dedo no banner
   - trava o lateral quando o gesto é de rolar a página
   ============================================================ */
(function () {

  function iniciar(ss) {
    if (ss.dataset.urzaTrilho) return;
    var lista = ss.querySelector('.slideshow__slide-list');
    var nav = ss.querySelector('page-dots');
    if (!lista || !nav || lista.children.length < 2) return;
    ss.dataset.urzaTrilho = '1';

    var dots = nav.querySelectorAll('button');
    var marcado = 0, ultimo = 0, fimTimer;

    function indice() { return Math.round(lista.scrollLeft / lista.clientWidth); }
    function irPara(i) { lista.scrollTo({ left: i * lista.clientWidth, behavior: 'smooth' }); }

    function marcar(i) {
      if (i === marcado) return;
      marcado = i;
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }

    /* o TEMA trocou (autoplay ou clique na barrinha): desliza até lá.
       Se o índice é o que nós mesmos marcamos, ignora — evita eco. */
    new MutationObserver(function () {
      var i = -1;
      dots.forEach(function (d, n) { if (d.getAttribute('aria-current') === 'true') i = n; });
      if (i < 0 || i === marcado) return;
      marcado = i;
      ultimo = i;
      irPara(i);
    }).observe(nav, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });

    /* destino do encaixe conhecido ao soltar o dedo (Chrome/Android) */
    lista.addEventListener('scrollsnapchanging', function (e) {
      var i = [].indexOf.call(lista.children, e.snapTargetInline);
      if (i >= 0) marcar(i);
    });

    lista.addEventListener('scroll', function () {
      marcar(indice());                     /* barrinha muda ao passar da metade */

      clearTimeout(fimTimer);
      fimTimer = setTimeout(function () {
        var i = indice();
        if (i === ultimo) return;
        ultimo = i;
        /* o CLIENTE arrastou: avisa o tema, que reinicia o tempo e o enchimento */
        if (typeof ss.select === 'function') { try { ss.select(i); } catch (e) {} }
      }, 120);
    }, { passive: true });

    /* relógio do tema parado enquanto o dedo está no banner */
    lista.urzaPausar = function () {
      if (typeof ss.pausePlayer === 'function') ss.pausePlayer();
    };
    lista.urzaRetomar = function () {
      if (ss.hasAttribute('auto-play') && typeof ss.startPlayer === 'function') ss.startPlayer();
    };
  }

  /* ---- GUARDA DE TOQUE -----------------------------------------
     Intercepta na captura, ANTES dos listeners do tema (que travavam
     a rolagem nativa). Nos primeiros pixels decide o eixo: se o gesto
     é mais vertical, trava o lateral até soltar.                    */
  var DECIDE_EM = 8;      /* PIXELS de movimento antes de decidir a direção */
  var INCLINACAO = 1;     /* 1 = 45°. Menor trava mais; maior trava menos */

  var toque = null;

    function guarda(e) {
    /* mouse passa direto: no PC o arrasto é o do próprio tema */
    if (e.pointerType === 'mouse') return;

    var lista = e.target.closest && e.target.closest('slide-show[data-urza-trilho] .slideshow__slide-list');
    if (!lista) return;
    e.stopPropagation();

    if (e.type === 'touchstart') {
      var t0 = e.touches[0];
      toque = { x: t0.clientX, y: t0.clientY, lista: lista, decidido: false };
      if (lista.urzaPausar) lista.urzaPausar();
      return;
    }

    if (e.type === 'touchmove' && toque && !toque.decidido) {
      var t1 = e.touches[0];
      var dx = Math.abs(t1.clientX - toque.x);
      var dy = Math.abs(t1.clientY - toque.y);
      if (dx + dy < DECIDE_EM) return;
      toque.decidido = true;
      if (dy > dx * INCLINACAO) lista.style.overflowX = 'hidden';
    }
  }

  function soltar() {
    if (!toque) return;
    var lista = toque.lista;
    if (lista.style.overflowX === 'hidden') {
      lista.style.overflowX = '';
      var i = Math.round(lista.scrollLeft / lista.clientWidth);
      lista.scrollTo({ left: i * lista.clientWidth, behavior: 'smooth' });
    }
    if (lista.urzaRetomar) lista.urzaRetomar();
    toque = null;
  }

  ['touchstart', 'touchmove', 'pointerdown', 'pointermove'].forEach(function (ev) {
    document.addEventListener(ev, guarda, { capture: true, passive: true });
  });
  ['touchend', 'touchcancel'].forEach(function (ev) {
    document.addEventListener(ev, soltar, { capture: true, passive: true });
  });

  function procurar() {
    document.querySelectorAll('slide-show').forEach(iniciar);
  }

  procurar();
  new MutationObserver(procurar).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   16. DESCRIÇÃO DO PRODUTO FECHADA NO CELULAR
   ------------------------------------------------------------
   No celular o tema mostra as abas como acordeão e abre a
   primeira (descrição). Aqui fechamos ao carregar a página.
   No PC continua em abas, onde uma sempre fica aberta.
   ============================================================ */
(function () {

  function fechar() {
    if (!window.matchMedia('(max-width: 999px)').matches) return;
    document.querySelectorAll('.product-tabs__tab-item-wrapper .collapsible-toggle[aria-expanded="true"]')
      .forEach(function (botao) { botao.click(); });
  }

  /* espera o tema terminar de montar o acordeão */
  if (document.readyState === 'complete') fechar();
  else window.addEventListener('load', fechar);
})();

/* ============================================================
   17. ZOOM NA TABELA DE MEDIDAS (celular)
   ------------------------------------------------------------
   Pinça amplia (até 4x) mirando o ponto entre os dedos; duplo
   toque amplia/volta; com zoom, um dedo arrasta. Sem zoom, o
   arrasto vertical rola a janela normalmente. Ao fechar a
   janela, volta ao tamanho original.
   ============================================================ */
(function () {
  if (!window.matchMedia('(pointer: coarse)').matches) return;   /* só telas de toque */

  var MAX = 4;          /* ZOOM máximo da pinça */
  var DUPLO = 2.5;      /* ZOOM do duplo toque */

  function preparar(img) {
    if (img.closest('.urza-zoom')) return;
    var caixa = document.createElement('div');
    caixa.className = 'urza-zoom';
    img.parentNode.insertBefore(caixa, img);
    caixa.appendChild(img);

    var dica = document.createElement('p');
    dica.className = 'urza-zoom__dica';
    dica.textContent = 'Use dois dedos ou toque duas vezes para ampliar';
    caixa.insertAdjacentElement('afterend', dica);

    ativar(caixa, img);
  }

  function ativar(caixa, img) {
    var s = 1, tx = 0, ty = 0, ini = null, moveu = false;
    var ultimoToque = 0, ultimoX = 0, ultimoY = 0;

    function limites() {
      var w = caixa.clientWidth, h = caixa.clientHeight;
      tx = Math.min(0, Math.max(w - w * s, tx));
      ty = Math.min(0, Math.max(h - h * s, ty));
    }
    function aplicar(anim) {
      img.classList.toggle('is-anim', !!anim);
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + s + ')';
      caixa.classList.toggle('is-zoom', s > 1.01);
    }
    function zerar(anim) { s = 1; tx = 0; ty = 0; aplicar(anim); }
    function ponto(t) {
      var r = caixa.getBoundingClientRect();
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    }
    function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    function meio(a, b) {
      var p = ponto(a), q = ponto(b);
      return { x: (p.x + q.x) / 2, y: (p.y + q.y) / 2 };
    }
    function iniciarArrasto(t) {
      var p = ponto(t);
      ini = { tipo: 'arrasto', tx: tx, ty: ty, x: p.x, y: p.y };
    }

    caixa.addEventListener('touchstart', function (e) {
      moveu = false;
      if (e.touches.length === 2) {
        ini = { tipo: 'pinca', s: s, tx: tx, ty: ty,
                d: dist(e.touches[0], e.touches[1]), m: meio(e.touches[0], e.touches[1]) };
      } else if (e.touches.length === 1) {
        iniciarArrasto(e.touches[0]);
      }
    }, { passive: true });

    caixa.addEventListener('touchmove', function (e) {
      if (!ini) return;
      if (ini.tipo === 'pinca' && e.touches.length === 2) {
        e.preventDefault(); moveu = true;
        var m = meio(e.touches[0], e.touches[1]);
        var novo = Math.min(MAX, Math.max(1, ini.s * dist(e.touches[0], e.touches[1]) / ini.d));
        tx = m.x - (ini.m.x - ini.tx) * (novo / ini.s);
        ty = m.y - (ini.m.y - ini.ty) * (novo / ini.s);
        s = novo; limites(); aplicar(false);
      } else if (ini.tipo === 'arrasto' && e.touches.length === 1) {
        var p = ponto(e.touches[0]);
        if (s > 1.01) {
          e.preventDefault(); moveu = true;
          tx = ini.tx + (p.x - ini.x); ty = ini.ty + (p.y - ini.y);
          limites(); aplicar(false);
        } else if (Math.abs(p.x - ini.x) > 8 || Math.abs(p.y - ini.y) > 8) {
          moveu = true;   /* sem zoom: deixa a janela rolar */
        }
      }
    }, { passive: false });

    caixa.addEventListener('touchend', function (e) {
      if (e.touches.length === 1) { iniciarArrasto(e.touches[0]); return; }  /* soltou um dedo da pinça */
      if (e.touches.length > 0) return;
      if (s < 1.05) zerar(true);

      if (!moveu && ini && ini.tipo === 'arrasto') {
        var agora = Date.now();
        if (agora - ultimoToque < 300 && Math.abs(ini.x - ultimoX) < 30 && Math.abs(ini.y - ultimoY) < 30) {
          if (s > 1.01) zerar(true);
          else {
            s = DUPLO; tx = ini.x - ini.x * s; ty = ini.y - ini.y * s;   /* amplia no ponto tocado */
            limites(); aplicar(true);
          }
          ultimoToque = 0;
        } else {
          ultimoToque = agora; ultimoX = ini.x; ultimoY = ini.y;
        }
      }
      ini = null;
    });

    /* janela fechou: volta ao tamanho normal */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ent) {
        if (!ent[0].isIntersecting) zerar(false);
      }).observe(caixa);
    }
  }

  function iniciar() {
    document.querySelectorAll('.urza-medidas__content img').forEach(preparar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();